// extracted by mini-css-extract-plugin
export default {"Header__Section":"Header_Header__Section__rHcZy","Main__Title":"Header_Main__Title__FHyWj","Description":"Header_Description__SXMxw","Header__Image":"Header_Header__Image__VehTy"};